import React, {useState,useEffect,} from 'react';
import { useNavigate,useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import { TextField,Typography,Box,Button,Grid } from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import {useAuth} from '../../context/auth-context'
import {useLocalStorage,} from '../../utils/hooks';
import { DEBUG_FLAG } from '../../constants/debug';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import { VERSION } from '../../constants/version';
import {
  isBrowser,
  isMobile,
  osName,
  osVersion,
  browserVersion,
  browserName,
  mobileModel
} from "react-device-detect";
import { useTranslation } from 'react-i18next';

function SupportButton(props) {
  const { t } = useTranslation();
  const [deviceId, ] = useLocalStorage(DEBUG_FLAG()?LOCAL_STORAGE_KEY.deviceIdLocal:LOCAL_STORAGE_KEY.deviceId);
  const [username] = useLocalStorage(LOCAL_STORAGE_KEY.username);
  const [deviceVersion,] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION);
  return (
    <Button
      href={"mailto:support@ectool.de?subject=Supportanfrage&body=%0d%0a%0d%0a%0d%0a------------------------------%0d%0aWichtige Informationen für ectool:%0d%0aBitte hier nichts verändern%0d%0aVersion: "+deviceVersion+"%0d%0aBuild: "+VERSION+"%0d%0aDeviceId: "+deviceId+"%0d%0aBetriebssystem: "+osName+"%0d%0aUsername: "+username+"%0d%0aAufruf: "+props.callLocation+"%0d%0aPfad: "+window.location.pathname+"%0d%0a------------------------------"}
      color="primary"
      fullWidth
      variant='outlined'
      >{t('Support kontaktieren')}</Button>
   )
}

export {SupportButton};